import { React } from "react";
import {
    Button,
    Typography,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
} from "@material-ui/core";
import useStyles from "../../themes/style.js";
import CloseIcon from "@material-ui/icons/Close";

const DropReasonDialogs = (props) => {
    const classes = useStyles(); 
    return (
        <div>
            <Dialog
                onClose={props.handleDropReasonClose}
                aria-labelledby="dialog-title"
                open={props.dropReasonOpen}
                width="md"
                PaperProps={{
                    style: {
                        width: "100%",
                    },
                }}
            >
                <DialogTitle className={classes.digTitle}>
                    <div className={classes.center}>
                        <Typography variant="subtitle2" className={classes.digColor + " " + classes.digCenter}> New Reason for drop this candidate </Typography>
                        <div className={classes.drawerClose} >
                            <CloseIcon
                                className={classes.digClose}
                                size="14px"
                                onClick={props.handleDropReasonClose}
                            />
                        </div>
                    </div>
                </DialogTitle>

                <DialogContent className={classes.chatListBackGround}>
                    <TextField
                        size="small"
                        classes={{ root: classes.customTextField }}
                        placeholder="Enter Reason for Drop this Candidate"
                        {...props.dropCandidates("reason")}
                        error={props.dropErrors.reason ? true : false}
                    />

                    <div className={classes.sendWhatsapp}>
                        <>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"

                                onClick={props.dropSubmit(props.DropStatus)}
                            >
                                Save
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                color='secondary'
                                onClick={props.handleDropReasonClose}
                            >
                                Close
                            </Button>
                        </>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default DropReasonDialogs

